<template>
  <section>
    <qx-search-box
        class="searchBox"
        :searchBoxData="searchBoxData"
        @sub="sub"
        title="筛选"
        :moreSearchVisible="true"
        permpisionsQuery=""
    >
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        goodsStatusOptions: [], // 货源状态
        form: [
          { // 货源编号
            label: '货源编号',
            value: 'id',
            type: 'input',
            placeholder: '请输入货源编号',
          },
          { // 线路名称
            label: '线路名称',
            value: 'lineName',
            type: 'input',
            placeholder: '请输入线路名称',
          },
          { // 客户名称
            label: '客户名称',
            value: 'customerName',
            type: 'input',
            placeholder: '请输入客户名称',
          },
          { // 货源状态
            label: '货源状态',
            value: 'goodsStatus',
            type: 'select',
            default: -1,
            placeholder: '请选择货源状态',
          },
          { // 货物名称
            label: '货物名称',
            value: 'goodsName',
            type: 'input',
            placeholder: '请输入货物名称',
          },
          { // 发布时间
            label: '发布时间',
            value: 'releaseTime',
            type: 'date',
            placeholder: '请选择发布时间',
            attr: {
              type: 'daterange',
            },
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 发布时间
      if (searchBoxData.releaseTime && searchBoxData.releaseTime.length > 0) {
        searchBoxData.releaseStartTime = this.formatDate(searchBoxData.releaseTime[0]);
        searchBoxData.releaseEndTime = this.formatDate(searchBoxData.releaseTime[1]);
        delete searchBoxData.releaseTime;
      }
      this.$refs.tableBox.saveSearchBoxData({...searchBoxData});
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'GOODS_STATE',
    });
    this.searchBoxData.goodsStatusOptions = [ // 货源状态
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[0],
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
